'use client';

import * as React from 'react';
export const CollapsibleContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CollapsibleContext.displayName = "CollapsibleContext";
export function useCollapsibleContext() {
  const context = React.useContext(CollapsibleContext);
  if (context === undefined) {
    throw new Error('MUI X: Missing context. Collapsible subcomponents must be placed within a <Collapsible /> component.');
  }
  return context;
}